import * as S from './styled'
import { useForm, SubmitHandler } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
/**
 * Components
*/
import LayoutWithList from '../../../LayoutModal/WithList';
import ActionButton from '../../../Button/ActionButton';
import Delete from '../../Delete';
import Update from '../Update';
/**
 * hooks
*/
import apiRequest from '../../../../hooks/apiRequest';
import { useMultipleModal } from '../../../../hooks/useMultipleModal';
import { useEffect, useState } from 'react';
/**
 * Icons 
*/
import { PencilSimple, Trash } from '@phosphor-icons/react';
/**
 * Interfaces
*/
import { Inputs, IBrands } from 'Interfaces/IBrands';

interface ICreate {
    isOpenModalBraind: boolean;
    setModalClose: () => void;
    refreshFrames: () => void;
}

export default function CreateBrainds(
    {
        isOpenModalBraind,
        setModalClose,
        refreshFrames
    }: ICreate) {

    const {
        register,
        handleSubmit: handleFormSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>();

    const tableHead = ['#', 'Nome', 'Ações'];
    const [data, setData] = useState<IBrands[]>([]);
    const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
    const { isOpenModal, toggleModalVisibility } = useMultipleModal();

    const clickPopTable = (id: number, acao: string) => {
        setOpenModalOptId(id);
        toggleModalVisibility(acao);
    };

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`brand`);
            setData(response.data);
        } catch (error) {
            console.log("Error: ", error);
        }
    };

    useEffect(() => {
        if (isOpenModalBraind) {
            fetchData();
        }
    }, [isOpenModalBraind]);

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            const formattedData = {
                ...data,
                brand: data.brand.toUpperCase(), // Aqui você força caixa alta
            };

            const response = await apiRequest('brand', 'POST', formattedData);
            if (response.status === 201) {
                alert("Grife criada com sucesso!");
                fetchData();
                refreshFrames();
            }
        } catch (error: any) {
            alert(error.message || "Ocorreu um erro ao criar o grife.");
        }
    };

    const onClose = () => {
        setModalClose();
        reset();
    }

    if (isOpenModalBraind) {
        return (
            <LayoutWithList
                title='Registrar Grife'
                subTitle='Cadastre uma nova grife em sua base de dados.'
                setModalClose={onClose}
            >
                <S.Container>
                    <S.SeparateDiv>
                        <S.FormInput>
                            <S.Label>
                                Grife
                                <span>*</span>
                            </S.Label>
                            <S.Input placeholder='Informe a grife' type='text' {...register("brand", { required: true })} />
                            {errors.brand && <S.InforErro>Campo Obrigatório</S.InforErro>}
                        </S.FormInput>
                        <S.ContentButton>
                            <ActionButton name='Salvar' onClick={handleFormSubmit(onSubmit)} />
                        </S.ContentButton>
                    </S.SeparateDiv>
                </S.Container>

                <S.Footer>
                    <S.TitleList>
                        Grifes Cadastradas
                    </S.TitleList>

                    <S.Table>
                        <thead>
                            <tr>
                                {
                                    tableHead.map((val) => {
                                        return (
                                            <th>{val}</th>
                                        )
                                    })
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((val, index) => {
                                return (
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{val.brand}</td>
                                        <td>
                                            <S.ContentButton>
                                                <S.ButtonIconTable onClick={() => clickPopTable(val.id, "update")}>
                                                    <PencilSimple size={20} />
                                                </S.ButtonIconTable>

                                                <S.ButtonIconTable onClick={() => clickPopTable(val.id, "delete")}>
                                                    <Trash size={20} color='red' />
                                                </S.ButtonIconTable>
                                            </S.ContentButton>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </S.Table>
                </S.Footer>

                <Update
                    isOpenModalBraind={isOpenModal("update")}
                    setModalClose={() => toggleModalVisibility("update")}
                    selectedUrlId={openModalOptId}
                    updateList={fetchData}
                />

                <Delete
                    updateList={fetchData}
                    endpoint="brand"
                    selectedProductId={openModalOptId}
                    isOpenModal={isOpenModal("delete")}
                    setModalClose={() => toggleModalVisibility("delete")}
                />
            </LayoutWithList>
        )
    } return null
}